<template>
  <div class="order-dialog" @contextmenu.stop>
    <el-dialog
      title="功能显示隐藏设置"
      width="500px"
      height="600px"
      top="calc( 50vh - 150px )"
      custom-class="order-dialog"
      center
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      :handleCancel="handleCancel"
    >
      <div class="title">
        <div>功能名称</div>
        <div>是否显示</div>
      </div>
      <div class="button-list">
        <div class="button-item">
          <div class="name">登录：</div>
          <el-radio-group v-model="login">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
        </div>
        <div class="button-item">
          <div class="name">分享：</div>
          <el-radio-group v-model="share">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="default-edit-footer" id="edit-footer">
        <div class="edit-footer-item right" @click="handleCancel()">取消</div>
        <div class="edit-footer-item left" @click="save()">确定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apis from '@api/paperManager'
export default {
  name: 'ButtonDisplaySet',
  data() {
    return {
      dialogVisible: false,
      login: 1,
      share: 1
    }
  },
  computed: {
    userName() {
      return localStorage.getItem('username')
    },
    booksCurrentSubAccount() {
      return this.$store.state.manage.booksCurrentSubAccount
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.initDisplay()
      }
    }
  },
  methods: {
    handleCancel() {
      this.dialogVisible = false
    },
    save() {
      let params = {
        userName: this.booksCurrentSubAccount || this.userName,
        switchGroup: JSON.stringify({ login: this.login, share: this.share })
      }
      apis.setSwitchGroup(params).then((res) => {
        if (res.data.status === 0) {
          this.dialogVisible = false
        } else {
          this.$alert('保存失败', '提示', {
            confirmButtonText: '确定'
          })
        }
      })
    },
    initDisplay() {
      apis.getGroupShareSetting(this.booksCurrentSubAccount || this.userName, 0).then((res) => {
        if (res.data.data && res.data.data.switchGroup) {
          let switchGroup = JSON.parse(res.data.data.switchGroup)
          this.login = switchGroup.login
          this.share = switchGroup.share
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.order-dialog {
  .title {
    display: flex;
    justify-content: space-evenly;
    background-color: #f4f4f4;
    height: 23px;
    line-height: 23px;
    font-weight: 600;
    color: #515151;
    div {
      width: 50%;
      text-align: center;
    }
  }
  .button-list {
    .button-item {
      display: flex;
      justify-content: space-evenly;
      height: 30px;
      line-height: 30px;
      .name {
        width: 50%;
        text-align: center;
      }
      .el-radio-group {
        width: 50%;
        text-align: center;
        .el-radio {
          height: 30px;
          line-height: 30px;
        }
      }
    }
  }
  .default-edit-footer {
    height: 50px;
    line-height: 36px;
    font-size: 14px;
    padding-top: 10px;
    background-color: #ffffff;
    text-align: center;

    .edit-footer-item {
      cursor: pointer;
      display: inline-block;
      height: 36px;
      border: 1px solid #df5813;
      text-align: center;
      width: 100px;
      &.left {
        background-color: #df5813;
        color: #fff;
      }
      &.right {
        margin-right: 30px;
      }
    }
  }
}
</style>
